// the main routes of our app are defined here using react-router
// https://reacttraining.com/react-router/web/example/basic
//
// includes a simple route change animation
// https://codesandbox.io/embed/YE6l8EmR9

import React from 'react'
import { Switch, Route } from 'react-router-dom'

import People from './people'
import PersonNew from './personNew'
import Account from './account'
import SnoozeDatePicker from './people/SnoozeDatePicker'

const Routes = () => (
  <div>
    <Route path="/chooseSnoozeDate/:personId" component={SnoozeDatePicker} />
    <Switch>
      <Route path="/person/add" component={PersonNew} />
      <Route path="/account" component={Account} />
      <Route path="/" component={People} />
    </Switch>
  </div>
)

export default Routes
 


// WEBPACK FOOTER //
// ./src/views/Routes.js